<template>
  <footer>
    <div class="center-wrapper">
      <div class="cicc-logo">
        <a href="http://www.cicc.com" target="_blank">
          <img src="@/assets/img/brand_logo.png" alt="cicc logo" />
        </a>
      </div>
      <div class="instruction">
        <p>
          &copy; 2011-2019 China International Capital Corporation Limited.
          京ICP备05004342号-1
        </p>
        <div>
          请使用<a
            href="http://www.google.cn/intl/zh-CN/chrome/"
            target="_blank"
            >Chrome浏览器</a
          >、<a href="http://se.360.cn/" target="_blank">360浏览器</a
          >极速模式以获得更好的使用体验。
        </div>
      </div>
      <a id="back-to-top" href="javascript:" title="返回顶部"></a>
    </div>
  </footer>
</template>
<script>
export default {
  name: "DefaultFooter",
};
</script>
<style lang="scss" scoped>
.center-wrapper {
  display: flex;
  margin: 0 auto;
  padding-left: 15.5%;
  gap: 8%;
  height: 115px;
}

.cicc-logo {
  margin-top: 2%;
}

.instruction {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 17px;
  margin-top: 3%;
}
</style>
